import { checkImageUrl, formatCurrency } from 'utils/modules/Handlers';
import './listingCard.scss';
import house1 from 'assets/images/house1.jpg'
import ListingStatus from 'components/ListingStatus';
import moment from 'moment';
import CustomButton from 'components/CustomButton';
import { useNavigate } from 'react-router-dom';


const ListingCard = ({ data, newTab }) => {
    const navigate = useNavigate();

    return (
        <div className="listing-card-component">
            <div className="header">
                <ListingStatus color={data.listing_status_color} text={data.listing_status} />
                <p className='time'>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <g clipPath="url(#clip0_754_69)">
                            <path d="M7.08334 1.39162C7.71179 1.75448 8.23457 2.27518 8.59993 2.90217C8.9653 3.52916 9.16058 4.2407 9.16644 4.96635C9.1723 5.692 8.98854 6.4066 8.63335 7.03941C8.27816 7.67222 7.76386 8.2013 7.14136 8.57426C6.51886 8.94722 5.80975 9.15113 5.08422 9.16582C4.35869 9.1805 3.64191 9.00544 3.00482 8.65798C2.36774 8.31051 1.83246 7.80268 1.45195 7.18476C1.07145 6.56684 0.858931 5.86025 0.835427 5.13496L0.833344 4.99996L0.835427 4.86496C0.858762 4.14537 1.06816 3.44411 1.44319 2.82954C1.81823 2.21497 2.34612 1.70806 2.97538 1.35824C3.60465 1.00842 4.31382 0.827623 5.03376 0.833473C5.7537 0.839324 6.45985 1.03162 7.08334 1.39162ZM5.00001 2.49996C4.89795 2.49997 4.79945 2.53744 4.72319 2.60526C4.64692 2.67307 4.5982 2.76652 4.58626 2.86787L4.58334 2.91662V4.99996L4.58709 5.05454C4.59659 5.12683 4.6249 5.19536 4.66918 5.25329L4.70543 5.29496L5.95543 6.54496L5.99459 6.57912C6.06767 6.63582 6.15752 6.66659 6.25001 6.66659C6.3425 6.66659 6.43235 6.63582 6.50543 6.57912L6.54459 6.54454L6.57918 6.50537C6.63587 6.4323 6.66664 6.34244 6.66664 6.24996C6.66664 6.15747 6.63587 6.06761 6.57918 5.99454L6.54459 5.95537L5.41668 4.82704V2.91662L5.41376 2.86787C5.40182 2.76652 5.3531 2.67307 5.27683 2.60526C5.20057 2.53744 5.10207 2.49997 5.00001 2.49996Z" fill="#2A2A2A" />
                        </g>
                        <defs>
                            <clipPath id="clip0_754_69">
                                <rect width="10" height="10" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    {moment(data.created_at).fromNow(true)} on market
                </p>
            </div>
            <img src={checkImageUrl(data.primary_photo_url, house1)} alt="" />
            <p className="price">{formatCurrency(data.price)}</p>
            <div className="content">
                <p className='id'>Listing #{data.mls_number || data.id}</p>
                <p className='name'>{data.property_type_display} in {data.city}</p>
                <p className='address'>
                    {
                        data.mls_number
                            ? <>{data.full_address}</>
                            : <>{`${data.address}, ${data.city} ${data.state} ${data.zip_code}`}</>
                    }
                </p>
                <p className="amenities">
                    {`${data.bedroom_count} Br | ${data.garage_spaces} Gar | ${data.bathroom_count} Fb | ${data.square_footage} Sq. Ft.`}
                </p>
            </div>
            {
                newTab
                ? <CustomButton size={'small'} text={'View Listing'} action={() => window.open(`${window.location.origin}/listings/${data.mls_source}/${data.mls_number || data.id}`)} />
                : <CustomButton size={'small'} text={'View Listing'} action={() => navigate(`/listings/${data.mls_source}/${data.mls_number || data.id}`)} />
            }
        </div>
    )
}

export default ListingCard;